import React from "react"
import Heading from "../../common/Heading"
import "./price.css"
import PriceCard from "./PriceCard"
import { useLanguage } from "../../../context/LanguageContext"

const Price = () => {
  const { content } = useLanguage()
  const { pricing } = content.home

  return (
    <>
      <section className='price padding'>
        <div className='container'>
          <Heading title={pricing.title} subtitle={pricing.subtitle} />
          <PriceCard />
        </div>
      </section>
    </>
  )
}

export default Price
